import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { IntegrationDetailBasicDataFragmentDoc } from './IntegrationDetailBasicData';
import { ScheduleFragmentDoc } from '../../../../../../1on1s/graphql/fragment/generated/Schedule';
export type IntegrationDetailFragment = { integrationFields?: Array<string> | null, existingIntegrationGroupIds: Array<string>, id: string, status: Types.IntegrationStatusEnum, connectedAt: string, scope: Types.IntegrationScopeEnum, settings?: { googleSettings?: { usersImportType: Types.UsersImportTypeEnum, userGroupIds: Array<string>, archiveTerminatedUsers: boolean, lastSyncedAt?: string | null, syncJobId?: string | null, syncStatus?: Types.JobEntityStatusEnum | null, syncSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, fieldMappings: Array<{ lyearnFieldName?: string | null, sourceFieldName: string, selectionAvailable: boolean, tagId?: string | null }> } | null, zoomSettings?: { connectionInfo: { userName: string, userEmailId: string } } | null, microsoftTeamsSettings?: { connectionInfo: { userName: string, userEmailId: string } } | null, jiraSettings?: { projectStatusesConfigs?: Array<{ project?: { id: string, name: string } | null, statuses?: Array<{ id: string, name: string, lyearnStatusId?: string | null }> | null }> | null, priorityConfigs?: Array<{ id: string, name: string, lyearnPriority?: Types.ActionItemPriorityEnum | null }> | null } | null, microsoftSettings?: { userGroupIds: Array<string>, usersImportType: Types.UsersImportTypeEnum, archiveTerminatedUsers?: boolean | null, lastSyncedAt?: string | null, syncJobId?: string | null, syncStatus?: Types.JobEntityStatusEnum | null, syncSchedule?: { frequency: Types.CronFrequencyEnum, timezone: string, time: string, dayOfWeek?: Types.DayOfWeekEnum | null, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, MonthOfYear?: Types.MonthOfYearEnum | null, startDate?: string | null, custom?: { frequency: Types.CustomFrequencyEnum, interval: number, daysOfWeek?: Array<Types.DayOfWeekEnum> | null, weekOfMonth?: Types.WeekOfMonthEnum | null, weeksOfMonth?: Array<Types.WeekOfMonthEnum> | null, dayOfMonth?: number | null, monthOfYear?: Types.MonthOfYearEnum | null } | null, endScheduleInfo?: { endScheduleType: Types.EndScheduleTypeEnum, date?: string | null, numberOfOccurrences?: number | null } | null } | null, fieldMappings: Array<{ lyearnFieldName?: string | null, sourceFieldName: string, selectionAvailable: boolean, tagId?: string | null }> } | null } | null, integrationGroups?: Array<{ id: string, name: string, icon?: string | null, membersCount?: number | null }> | null, connectedBy?: { name?: string | null, id: string, profilePicture?: string | null } | null };


export type IntegrationDetailFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const IntegrationDetailFragmentDoc = /*#__PURE__*/ gql`
    fragment IntegrationDetail on IntegrationDetailType {
  ...IntegrationDetailBasicData
  settings {
    googleSettings {
      usersImportType
      userGroupIds
      archiveTerminatedUsers
      lastSyncedAt
      syncJobId
      syncStatus
      syncSchedule {
        ...Schedule
      }
      fieldMappings {
        lyearnFieldName
        sourceFieldName
        selectionAvailable
        tagId
      }
    }
    zoomSettings {
      connectionInfo {
        userName
        userEmailId
      }
    }
    microsoftTeamsSettings {
      connectionInfo {
        userName
        userEmailId
      }
    }
    jiraSettings {
      projectStatusesConfigs {
        project {
          id
          name
        }
        statuses {
          id
          name
          lyearnStatusId
        }
      }
      priorityConfigs {
        id
        name
        lyearnPriority
      }
    }
    microsoftSettings {
      userGroupIds
      usersImportType
      archiveTerminatedUsers
      lastSyncedAt
      syncJobId
      syncStatus
      syncSchedule {
        ...Schedule
      }
      fieldMappings {
        lyearnFieldName
        sourceFieldName
        selectionAvailable
        tagId
      }
    }
  }
  integrationFields
  integrationGroups {
    id
    name
    icon
    membersCount
  }
  existingIntegrationGroupIds
}
    `;